import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

let amount = 0;

function ListGroup(props) {
  const [open, setOpen] = useState(!!props.open);
  const [id] = useState(() => {
    amount++;
    return props.id || 'list-group-' + amount;
  });
  const { t } = useTranslation('dealers');

  // Toggle open state
  const openCallback = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(props.alwaysOpen ? true : !open);
  };

  return (
    <div className={'dealer-list-group' + (props.alwaysOpen ? ' always-open' : '')}>
      <div className='dealer-list-group__header' onClick={openCallback}>
        <h3 id={id + '-title'} className='dealer-list-group__title'>{props.title}</h3>
        {!props.alwaysOpen && (
          <button className='button dealer-list-group__toggle-button' type='button' onClick={openCallback} aria-label={props.toggleLabel || t('Open')} aria-expanded={open ? 'true' : 'false'} aria-controls={id + '-content'}></button>
        )}
      </div>
      <div id={id + '-content'} className={'dealer-list-group__content' + (open ? ' open' : '')} role='region' aria-labelledby={id + '-title'}>{props.children}</div>
    </div>
  );
}

ListGroup.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  toggleLabel: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  alwaysOpen: PropTypes.bool,
};

export default ListGroup;
